import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  navLink: {
    cursor: 'pointer',
    color: 'var(--text-color)',
    opacity: 0.7,
    transition: 'opacity 0.3s',
    fontFamily: 'Montserrat',
    fontWeight: 600,
    fontSize: '16px',
    '&:hover': {
      opacity: 1,
    },
  },
  searchTitle: {
    fontSize: 18,
    fontWeight: '400',
    paddingBottom: 15,
    color: 'var(--text-color)',
    fontFamily: 'Montserrat',
    display: 'block',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  favoritesPopper: {
    zIndex: 1301,
    marginTop: '-10px !important',
    '& .MuiPaper-root': {
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.5)',
    },
  },
  favoritesPaper: {
    borderRadius: 10,
    minWidth: 200,
    maxWidth: 360,
    backdropFilter: 'blur(10px)',
    backgroundColor: 'var(--background-color-secondary) !important',
  },
  favoritesList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',

    maxHeight: 520,
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: 8,
    },
    '&::-webkit-scrollbar-track': {
      background: '#1a1a1a',
      borderRadius: 4,
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(255, 255, 255, 0.2)',
      borderRadius: 4,
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: 'var(--divider-color)',
    },
  },
  favoriteItem: {
    padding: '10px 20px !important',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    width: '100%',
    justifyContent: 'flex-start',
    height: 'auto',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: 'var(--hover-color)',
    },
    '& .MuiBox-root': {
      alignItems: 'flex-start',
    },
    '& .MuiTypography-root': {
      color: 'var(--text-color)',
      fontSize: 16,
      fontWeight: 500,
      transition: 'color 0.2s ease',
      textAlign: 'center',
    },
    '&:hover .MuiTypography-root': {
      color: 'var(--text-color)',
    },
  },
  noFavorites: {
    padding: '10px 20px',
    color: 'var(--text-color)',
    fontSize: 14,
    opacity: 0.6,
    fontStyle: 'italic',
  },
  rippleEffect: {
    color: 'var(--text-color)',
    opacity: 0.4,
  },
  rotateAllButton: {
    width: '100%',
    justifyContent: 'center',
    padding: '10px 20px !important',
    borderBottom: '1px solid var(--divider-color)',
    marginBottom: 8,
    gap: 8,
    '&:hover': {
      backgroundColor: 'var(--hover-color)',
    },
    '& .MuiTypography-root': {
      color: 'var(--accent-primary)',
      fontSize: 14,
      fontWeight: 500,
    },
  },
  rotateIcon: {
    color: 'var(--accent-primary)',
    fontSize: 20,
  },
  favTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  mobileIcon: {
    display: 'none !important',
    color: 'var(--accent-primary)',
    fontSize: 24,
    [theme.breakpoints.down('sm')]: {
      display: 'block !important',
      paddingBottom: 15,
    },
  },
  podcastIcon: {
    width: 16,
    height: 16,
    minWidth: 16,
    minHeight: 16,
    marginRight: 8,
    flexShrink: 0,
    transform: 'translateY(2px)',
  },
}));
